import React, { useState } from 'react';
import { fetchWithAuth } from '../../utils/auth';

const ApoioCliente: React.FC = () => {
  const [name, setName] = useState('');
  const [problem, setProblem] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState<{ type: 'success' | 'error'; text: string } | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    setMessage(null);
    try {
      const res = await fetchWithAuth('/api/support/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, message: problem })
      });

      if (res.ok) {
        setMessage({ type: 'success', text: 'Recebemos o seu pedido. Entraremos em contacto em breve.' });
        setName('');
        setProblem('');
      } else {
        setMessage({ type: 'error', text: 'Não foi possível enviar o pedido. Tente novamente.' });
      }
    } catch (err) {
      console.error('Erro ao enviar pedido de apoio:', err);
      setMessage({ type: 'error', text: 'Ocorreu um erro ao enviar. Tente novamente.' });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-white">Apoio ao Cliente</h2>
          <p className="text-sm text-[#94a3b8]">Estamos aqui para ajudar — descreva o seu problema</p>
        </div>
      </div>

      {message && (
        <div
          className={`p-4 rounded-lg border text-sm ${
            message.type === 'success'
              ? 'bg-emerald-500/10 border-emerald-500/30 text-emerald-200'
              : 'bg-rose-500/10 border-rose-500/30 text-rose-200'
          }`}
        >
          {message.text}
        </div>
      )}

      <div className="rounded-xl border border-[#111827] bg-[#0b1220] shadow-[0_12px_40px_rgba(0,0,0,0.35)]">
        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-[#cbd5e1] mb-1">Nome</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              className="w-full px-4 py-2 rounded-lg bg-[#0b1220] border border-[#111827] text-[#e5e7eb] placeholder-[#64748b] focus:ring-2 focus:ring-[#8b5cf6] focus:border-transparent"
              placeholder="O seu nome"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-[#cbd5e1] mb-1">Problema</label>
            <textarea
              value={problem}
              onChange={(e) => setProblem(e.target.value)}
              required
              rows={6}
              className="w-full px-4 py-2 rounded-lg bg-[#0b1220] border border-[#111827] text-[#e5e7eb] placeholder-[#64748b] focus:ring-2 focus:ring-[#8b5cf6] focus:border-transparent"
              placeholder="Descreva o que está a acontecer, com o máximo de detalhe possível..."
            />
          </div>

          <div className="flex justify-end">
            <button
              type="submit"
              disabled={submitting}
              className="px-5 py-2 rounded-full bg-gradient-to-r from-[#8b5cf6] to-[#ec4899] text-white font-medium hover:brightness-110 transition disabled:opacity-60 disabled:cursor-not-allowed"
            >
              {submitting ? 'A enviar…' : 'Enviar pedido'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ApoioCliente;
